export default {
  title: 'Wie gefällt dir {{name}}?',
  description: 'Dein Feedback ist anonym und hilft uns, uns zu verbessern.',
  upload_google_review: {
    title: 'Wir belohnen dich',
  },
};
